module.exports = __webpack_public_path__ + "static/media/6530.56532910.jpg";